import React, { Fragment, useState, useEffect } from 'react';
import { classStudentNotification } from '../../../../Store/api/professor/settings';
import { useDispatch } from 'react-redux';
import ArrowRight from '../../../../assets/images/Arrow-right-dark.svg';

const NotificationSettings = ({ studentNot, classId, setClassSettingProperties }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notf, setNotf] = useState(studentNot);
  const dispatch = useDispatch();

  useEffect(() => {
    setNotf(studentNot);
  }, [studentNot, isEditing]);

  return (
    <div className='box_border_settings'>
      <div className='settings_header'>
        <div className='d-flex justify-content-between align-items-center'>
          <h2>student notifications</h2>
        </div>
        <div className='settings_header'>
          <div className='mb-0 editt cursor d-flex align-items-center'>
            <p
              className={`text-uppercase mb-0 ${isEditing ? 'text-decoration-none' : ''}`}
              onClick={() => {
                setIsEditing(true);
              }}
            >
              {isEditing ? 'editing' : 'edit'}
            </p>
          </div>
        </div>
      </div>
      <div className='d-flex justify-content-between align-items-center'>
        <p className='key'>Recieve alerts?</p>

        {isEditing ? (
          <Fragment>
            {/* <p className="value w-30"></p> */}
            <div className='d-flex justify-content-between align-items-center w-20 mb-12'>
              <label
                for='yes'
                onClick={(e) => {
                  setNotf(true);
                }}
              >
                Yes
                <input type='radio' name='noti' id='yes' value={'yes'} checked={notf} className='custome_radio cursor' />
                <span></span>
              </label>
              <label
                for='no'
                onClick={(e) => {
                  setNotf(false);
                }}
              >
                No
                <input type='radio' name='noti' id='no' checked={!notf} value={'yes'} className='custome_radio cursor' />
                <span></span>
              </label>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <p style={{ width: '10%' }}></p>
            <p
              style={{
                width: '40%',
                display: 'flex',
                justifyContent: 'right',
                textAlign: 'right',
                alignItems: 'center',
              }}
            >
              <p>{studentNot ? 'Yes' : 'No'}</p>
            </p>
          </Fragment>
        )}
      </div>

      {isEditing && (
        <div className='setting_rows' style={{ marginBottom: '0px' }}>
          <p className='key'></p>
          <p className='value'>
            <p className='main_part'></p>
            <p
              className='edit_buttton cursor'
              style={{ fontSize: 14, fontWeight: 500 }}
              onClick={() => {
                setIsLoading(true);
                dispatch(
                  classStudentNotification({
                    body: { studentNotifications: notf },
                    id: classId,
                    onSuccess: (res) => {
                      setClassSettingProperties('studentNotification', notf);
                      setIsLoading(false);
                      setIsEditing(false);
                    },
                    onError: (error) => {
                      if (error.response && error.response && error.response.data.message) {
                        window.alert(error.response.data.message);
                      } else {
                        window.alert('Unknown error!!');
                      }
                      setIsLoading(false);
                    },
                  })
                );
              }}
            >
              Save <img src={ArrowRight} alt='save' />
            </p>
          </p>
        </div>
      )}
    </div>
  );
};
export default NotificationSettings;
